<template>
  <div class="topnav-giving-back-container">
    <a
      v-for="item in localItems"
      :key="item.image"
      :href="item.link"
      class="giving-back-item"
    >
      <img class="giving-back-image" :src="item.image" :alt="item.alt" />
      <div class="image-text">
        <p class="image-title" v-html="item.text" />
      </div>
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import VueMq from "vue-mq";

import { ConfigService } from "@nuskin/ns-util";

import { getImagesFromJson } from "../utils/helpers";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 375,
    phablet: 768,
    tablet: 1024,
    desktop: 1440,
    desktopHD: Infinity
  }
});

export default {
  name: "NsTopnavGivingBack",
  props: {
    /**
     * Product items (max: 4): [{image, alt, link}]
     */
    items: {
      type: String,
      default: JSON.stringify([])
    }
  },
  data: function() {
    return {
      localItems: []
    };
  },
  watch: {
    items(newVal) {
      this.setItems(newVal);
    }
  },
  mounted: function() {
    this.setItems();
  },
  methods: {
    setItems(val = this.items) {
      const marketConfig = ConfigService.getMarketConfig();
      this.localItems = getImagesFromJson(marketConfig.siteUrl, val);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@nuskin/ns-core-styles/src/scss/_global.mixins";
@import "~@nuskin/ns-core-styles/src/scss/globalVariables";

.topnav-giving-back-container {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(4, 200px);
  grid-column-gap: 20px;
  padding: 40px 20px;
}

.giving-back-item {
  text-decoration: none;

  &:hover .image-title {
    border-bottom: 1px solid currentColor;
  }
}

.giving-back-image {
  flex: 1 0 0;
  display: block;
  max-height: 160px;
  min-height: 100px;
  max-width: 200px;
  min-width: 100px;
  object-fit: contain;
}

.image-text {
  display: flex;
  justify-content: center;
}

.image-title {
  display: inline-block;
  margin: 0;
  margin-top: 10px;
  border-bottom: 1px solid transparent;
  font-weight: 600;
  line-height: normal;
}

@media (max-width: 1023px) {
  .topnav-giving-back-container {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 20px 20px;
  }

  .giving-back-image {
    margin: 0 auto;
    min-height: 200px;
    min-width: 200px;
  }
}
</style>
